import { render, staticRenderFns } from "./MigrateWizard.vue?vue&type=template&id=18be9346&scoped=true&"
import script from "./MigrateWizard.vue?vue&type=script&lang=js&"
export * from "./MigrateWizard.vue?vue&type=script&lang=js&"
import style0 from "./MigrateWizard.vue?vue&type=style&index=0&id=18be9346&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be9346",
  null
  
)

export default component.exports